export default __webpack_public_path__ + "static/national-yards-desktop-2ac9189636d5b4d1098aab5b05b406d8.svg";